// FBC
import FBC1 from "../../assets/Gallery/2014_Flute_Boot_Camp/jpeg-optimizer_2014_FBC_1.jpeg"
import FBC2 from "../../assets/Gallery/2014_Flute_Boot_Camp/jpeg-optimizer_2014_FBC_2.jpeg"
import FBC3 from "../../assets/Gallery/2014_Flute_Boot_Camp/jpeg-optimizer_2014_FBC_3.jpeg"
import FBC4 from "../../assets/Gallery/2014_Flute_Boot_Camp/jpeg-optimizer_2014_FBC_4.jpeg"
import FBC5 from "../../assets/Gallery/2014_Flute_Boot_Camp/jpeg-optimizer_2014_FBC_5.jpeg"
import FBC6 from "../../assets/Gallery/2014_Flute_Boot_Camp/jpeg-optimizer_2014_FBC_6.jpeg"
import FBC7 from "../../assets/Gallery/2014_Flute_Boot_Camp/jpeg-optimizer_2014_FBC_7.jpeg"
import FBC8 from "../../assets/Gallery/2014_Flute_Boot_Camp/jpeg-optimizer_2014_FBC_8.jpeg"
import FBC9 from "../../assets/Gallery/2014_Flute_Boot_Camp/jpeg-optimizer_2014_FBC_9.jpeg"
import FBC10 from "../../assets/Gallery/2014_Flute_Boot_Camp/jpeg-optimizer_2014_FBC_10.jpeg"
import FBC11 from "../../assets/Gallery/2014_Flute_Boot_Camp/jpeg-optimizer_2014_FBC_11.jpeg"
import FBC12 from "../../assets/Gallery/2014_Flute_Boot_Camp/jpeg-optimizer_2014_FBC_12.jpeg"
import FBC13 from "../../assets/Gallery/2014_Flute_Boot_Camp/jpeg-optimizer_2014_FBC_13.jpeg"
import FBC14 from "../../assets/Gallery/2014_Flute_Boot_Camp/jpeg-optimizer_2014_FBC_14.jpeg"
import FBC15 from "../../assets/Gallery/2014_Flute_Boot_Camp/jpeg-optimizer_2014_FBC_15.jpeg"
import FBC16 from "../../assets/Gallery/2014_Flute_Boot_Camp/jpeg-optimizer_2014_FBC_16.jpeg"
import FBC17 from "../../assets/Gallery/2014_Flute_Boot_Camp/jpeg-optimizer_2014_FBC_17.jpeg"
import FBC18 from "../../assets/Gallery/2014_Flute_Boot_Camp/jpeg-optimizer_2014_FBC_18.jpeg"

// Keith Underwood
import KeithUnderwood1 from "../../assets/Gallery/Keith_Underwood_Master_Class/jpeg-optimizer_KeithUnderwood1.jpeg"
import KeithUnderwood2 from "../../assets/Gallery/Keith_Underwood_Master_Class/jpeg-optimizer_KeithUnderwood2.jpeg"
import KeithUnderwood3 from "../../assets/Gallery/Keith_Underwood_Master_Class/jpeg-optimizer_KeithUnderwood3.jpeg"

// 2014 BreakAway Adult Flute Vacation
import Adult1 from "../../assets/Gallery/2014_Adult_Flute_Vacation/jpeg-optimizer_Adult1.jpeg"
import Adult2 from "../../assets/Gallery/2014_Adult_Flute_Vacation/jpeg-optimizer_Adult2.jpeg"
import Adult3 from "../../assets/Gallery/2014_Adult_Flute_Vacation/jpeg-optimizer_Adult3.jpeg"
import Adult4 from "../../assets/Gallery/2014_Adult_Flute_Vacation/jpeg-optimizer_Adult4.jpeg"

export const sectionsGalleryData = [
  {
    sectionName: "2014 Flute Boot Camp",
    images: [FBC1, FBC2, FBC3, FBC4, FBC5, FBC6, FBC7, FBC8, FBC9, FBC10, FBC11, FBC12, FBC13, FBC14, FBC15, FBC16, FBC17, FBC18],
    imagesPerRow: [1, 3, 3, 1, 3, 3, 3, 1],
  },
  {
    sectionName: "Keith Underwood Master Classes",
    images: [KeithUnderwood1, KeithUnderwood2, KeithUnderwood3],
    imagesPerRow: [3],
  },
  {
    sectionName: "2014 BreakAway Adult Flute Vacation",
    images: [Adult1, Adult2, Adult3, Adult4],
    imagesPerRow: [3, 3]
  }
];
